import React, { useState } from "react";
import { useGet } from "../../hooks/api";
import { apiUrls } from "../../utils/urls";
import { List, ListSubheader, Divider, Typography, Box } from "@mui/material";
import useDisclosure from "../../hooks/ui/useDisclosure";
import ToDoTemplateFormDialog from "../ToDoTemplateFormDialog";
import { useConfirm } from "material-ui-confirm";
import ToDoTemplateListItem from "./ToDoTemplateListItem";
import api from "../../utils/api";
import { showSuccessSnackbar } from "../../utils/feedback";

export default function ToDoTemplateList({ filters, onChange }) {
  const { data, isLoading, error, refetch } = useGet(
    apiUrls.admin.toDoTemplates(),
    {
      params: {
        keep_related: true,
        search_params: filters,
      },
      staleTime: 0,
    }
  );
  const confirm = useConfirm();
  const editDisclosure = useDisclosure();
  const [selectedToDoTemplate, setSelectedToDoTemplate] = useState(null);

  // Stubbed delete handler — replace with your real delete logic
  const handleDelete = (template) => {
    confirm({
      title: "Are you sure?",
      content: (
        <Box>
          <Typography variant="body1">
            Please confirm that you want to delete:
          </Typography>
          <ToDoTemplateListItem template={template} showActions={false} />
          <Typography variant="subtitle1" color="red">
            WARNING: This action is irreversible and will remove the item from
            all to-do lists.
          </Typography>
        </Box>
      ),
      confirmationText: "Confirm",
    })
      .then(async () => {
        const response = await api.delete(
          apiUrls.admin.toDoTemplate(template.uuid)
        );
        if (response.status == 200) {
          showSuccessSnackbar("To-do Item Deleted.");
          refetch();
          if (onChange) {
            onChange();
          }
        }
      })
      .catch(() => {});
  };

  const toDoTemplates = data?.data || [];

  if (isLoading) {
    return <Typography>Loading templates...</Typography>;
  }
  if (error) {
    return <Typography color="error">Failed to load templates.</Typography>;
  }

  return (
    <>
      {selectedToDoTemplate && (
        <ToDoTemplateFormDialog
          toDoTemplateId={selectedToDoTemplate.uuid}
          {...editDisclosure.getDisclosureProps()}
          onSubmit={() => {
            editDisclosure.onClose();
            refetch();
            if (onChange) {
              onChange();
            }
          }}
        />
      )}
      {toDoTemplates.length ? (
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 1,
            overflow: "hidden",
          }}
        >
          <List
            subheader={
              <ListSubheader
                component="div"
                sx={{ bgcolor: "primary.main", color: "primary.contrastText" }}
              >
                To-Do Items
              </ListSubheader>
            }
          >
            {toDoTemplates.map((template, idx) => (
              <React.Fragment key={template.uuid}>
                <ToDoTemplateListItem
                  template={template}
                  showActions={!filters.upcoming}
                  onEdit={() => {
                    setSelectedToDoTemplate(template);
                    editDisclosure.onOpen();
                    if (onChange) {
                      onChange();
                    }
                  }}
                  onDelete={() => handleDelete(template)}
                />
                {idx < toDoTemplates.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        </Box>
      ) : (
        <Typography variant="body1">No to-do items.</Typography>
      )}
    </>
  );
}
